import Isotope from 'isotope-layout';
import IsotopeFitColumns from 'isotope-fit-columns';
// mobile filters open/close
const searchDialog = document.getElementById('filter-dialog');
const openSearchDialog = document.querySelector('[aria-controls="filter-dialog"]');
const closeSearchDialog = document.getElementById('close-search-dialog');
openSearchDialog.addEventListener('click', function () {
    searchDialog.showModal();
    openSearchDialog.setAttribute('aria-expanded', 'true');
});
closeSearchDialog.addEventListener('click', function () {
    searchDialog.close();
    openSearchDialog.setAttribute('aria-expanded', 'false');
});

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#stores-grid');
  if (!grid) {
    console.error('Grid element not found (#stores-grid)');
    return;
  }

  const iso = new Isotope(grid, {
    itemSelector: '.store-item',
    layoutMode: 'fitRows', // default
    // optional: transitionDuration: '0.25s'
  });

  // Filters
  const storeFilter    = document.getElementById('store-filter');
  const categoryFilter = document.getElementById('category-filter');
  const floorFilter    = document.getElementById('floor-filter');
  const searchBtn      = document.getElementById('search-btn');

  function getFilterValues() {
    return {
      store: storeFilter?.value || '*',
      category: categoryFilter?.value || '*',
      floor: floorFilter?.value || '*'
    };
  }

  function filterGrid() {
    const { store, category, floor } = getFilterValues();
    iso.arrange({
      filter: itemElem => {
        const d = itemElem.dataset;
        const matchStore = store === '*' || d.store.trim() === store;
        // const matchCategory = category === '*' || d.category === category;
        const matchCategory = category === '*' || (d.category && d.category.split(',').some(cat => cat.trim() === category));
        const matchFloor = floor === '*' || d.floor.trim() === floor;
        return matchStore && matchCategory && matchFloor;
      }
      // Note: we are NOT changing layoutMode here; only filtering
    });
  }

  // Filter only when search is clicked (as per your current approach)
  if (searchBtn) searchBtn.addEventListener('click', filterGrid);

  // Initial show all
  filterGrid();

  // Layout mode radio handling
  const layoutRadios = document.querySelectorAll('input[name="layout-mode"]');

  function changeLayoutMode(mode) {
    // Optionally toggle a helper class for styling differences
    if (mode !== 'fitRows') {
      grid.classList.add('is-vertical');
    } else {
      grid.classList.remove('is-vertical');
    }

    // Change layout mode while preserving current filter
    // iso.arrange({ layoutMode: mode });
    // Force a re-layout after potential width changes
    iso.layout();
  }

  layoutRadios.forEach(radio => {
    radio.addEventListener('change', e => {
      if (e.target.checked) {
        const mode = e.target.value;
        // const mode = e.target.value;
        changeLayoutMode(mode);
      }
    });
  });
});